//libs
import React, { memo, useState, MouseEvent } from 'react';

// hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//styles
import {
  Popularlinks,
  Button,
  Row,
  Wrapper,
  LinkTitle,
  Anchor,
  Separator,
  Dot,
  InlineSpace,
} from './styles';

//icons
import ChevronDown from '@nykaa/ui-components/Icons/chevron-down-small';
import ChevronUp from '@nykaa/ui-components/Icons/chevron-up-small';

//data
import { popularLinks } from 'shared/components/Footer/data';

// helpers
import { saveAnalytics } from 'shared/components/Footer/helpers';

//constants
import { ICON_SIZES, TITLES } from 'shared/components/Footer/constants';

function PopularLinks() {
  const theme: Theme = useTheme();
  const [isExpanded, setExpanded] = useState(false);
  const toggle = (e: MouseEvent) => {
    e.preventDefault();
    setExpanded(!isExpanded);
  };
  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    saveAnalytics();
    window.open(e.target?.href);
  };
  return (
    <Popularlinks>
      <Button onClick={toggle}>
        {TITLES.POPULAR_LINKS}
        {isExpanded ? (
          <ChevronUp color={theme.colors.textSecondary} size={ICON_SIZES.DWEB} />
        ) : (
          <ChevronDown size={ICON_SIZES.DWEB} color={theme.colors.textSecondary} />
        )}
      </Button>

      <Wrapper isExpanded={isExpanded}>
        <Separator />
        {popularLinks.map((heading: typeof popularLinks[0]) => (
          <Row key={`row_${heading.title}`}>
            <LinkTitle> {heading.title}</LinkTitle>
            {heading.links.map((link: typeof heading.links[0]) => (
              <InlineSpace key={`item_${link.text}`}>
                <Dot />
                <Anchor
                  key={`link_${link.text}`}
                  href={link.href}
                  target="_blank"
                  onClick={onClick}
                >
                  {link.text}
                </Anchor>
              </InlineSpace>
            ))}
          </Row>
        ))}
      </Wrapper>
    </Popularlinks>
  );
}

export default memo(PopularLinks);
